import React from 'react';
import styled from 'styled-components';
import { 
	bool,
	string,
	func,
	node
} from 'prop-types';
import {
	DefaultPrimaryColor,
	LightPrimaryColor,
	DividerColor,
	ColorDefs,
	Grey50,
	Grey500,
	AccentColor,
	LightAccentColor
} from '../../Colors';

const colors = {
	[ColorDefs.default] : {
		checked:Grey500,
		unchecked:Grey50,
	},
	[ColorDefs.primary] : {
		checked:DefaultPrimaryColor,
		unchecked:LightPrimaryColor,
	},
	[ColorDefs.secondary] : {
		checked:AccentColor,
		unchecked:LightAccentColor,
	}
};

const Container = styled.div`
    display: flex;
    align-items:center;
    position: relative;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    & > button {
        background-color: ${ ({bgColor}) => bgColor};
    }
    &:hover{
        & > button {
            background-color: ${ ({hoverColor}) => hoverColor};
        }
    }
`;

const CheckBoxBase = styled.button`
    position: relative;
    margin-right : 0.5rem;
    border : none;
    height: 25px;
    width: 25px;
    border-radius:4px;
    &:focus {outline:0;}
`;

const Checkmark = styled(CheckBoxBase)`
    &:after {
        content: "";
        position: absolute;
        left: 9px;
        top: 5px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }
`;

const UncheckedMark = styled(CheckBoxBase)`
    background-color: transparent;
    border : 1px solid ${DividerColor};
`;



export default class Checkbox extends React.PureComponent {
    static propTypes = {
    	checked:bool,
    	color:string,
    	className:string,
    	onCheck:func.isRequired,
    	children:node
    }
    render(){
    	const {onCheck,children,checked,color=ColorDefs.default,className} = this.props;
    	const onClick = ()=>{
    		if(onCheck) onCheck(!checked);
    	};
    	const colorDef = colors[color] || colors[ColorDefs.default];
    	return checked ? (
    		<Container className={className} onClick={onClick} bgColor={colorDef.checked} hoverColor={colorDef.checked}>
    			<Checkmark/>
    			{children}
    		</Container>
    	) : (
    		<Container className={className} onClick={onClick} bgColor={'transparent'} hoverColor={colorDef.unchecked}>
    			<UncheckedMark />
    			{children}
    		</Container>
    	);
    }   
}
